import { combineReducers, createStore } from 'redux'
import { persistStore } from 'redux-persist'

import account from 'features/account/account-slice'
import address from 'features/address/address-slice'
import approvalRequest from 'features/approvalRequest/approvalRequest-slice'
import approvalRequestLog from 'features/approvalRequestLog/approvalRequestLog-slice'
import approvedMedia from 'features/approvedMedia/approvedMedia-slice'
import approvedSeries from 'features/approvedSeries/approvedSeries-slice'
import branding from 'features/branding/branding-slice'
import brandingResource from 'features/brandingResource/brandingResource-slice'
import cast from 'features/cast/cast-slice'
import category from 'features/category/category-slice'
import categoryValue from 'features/categoryValue/categoryValue-slice'
import changeLog from 'features/changeLog/changeLog-slice'
import checkoutSession from 'features/checkoutSession/checkoutSession-slice'
import coherentScreen from 'features/coherentScreen/coherentScreen-slice'
import coherentScreenMediaReference from 'features/coherentScreenMediaReference/coherentScreenMediaReference-slice'
import comment from 'features/comment/comment-slice'
import commentCreateUpdateArg from 'features/commentCreateUpdateArg/commentCreateUpdateArg-slice'
import contentCarrier from 'features/contentCarrier/contentCarrier-slice'
import contentCreator from 'features/contentCreator/contentCreator-slice'
import contentCreatorInvitation from 'features/contentCreatorInvitation/contentCreatorInvitation-slice'
import contentCreatorInvite from 'features/contentCreatorInvite/contentCreatorInvite-slice'
import contentHouse from 'features/contentHouse/contentHouse-slice'
import contentHouseMediaSnapshot from 'features/contentHouseMediaSnapshot/contentHouseMediaSnapshot-slice'
import curatedMediaList from 'features/curatedMediaList/curatedMediaList-slice'
import curatedSeriesList from 'features/curatedSeriesList/curatedSeriesList-slice'
import customerAdministrator from 'features/customerAdministrator/customerAdministrator-slice'
import customerSettings from 'features/customerSettings/customerSettings-slice'
import device from 'features/device/device-slice'
import deviceSettings from 'features/deviceSettings/deviceSettings-slice'
import expressedPreference from 'features/expressedPreference/expressedPreference-slice'
import feedback from 'features/feedback/feedback-slice'
import flag from 'features/flag/flag-slice'
import game from 'features/game/game-slice'
import gameArtifact from 'features/gameArtifact/gameArtifact-slice'
import gameConfig from 'features/gameConfig/gameConfig-slice'
import gameContext from 'features/gameContext/gameContext-slice'
import gameLog from 'features/gameLog/gameLog-slice'
import gameMarketingResource from 'features/gameMarketingResource/gameMarketingResource-slice'
import gameMetric from 'features/gameMetric/gameMetric-slice'
import genericResult from 'features/genericResult/genericResult-slice'
import history from 'features/history/history-slice'
import issue from 'features/issue/issue-slice'
import log from 'features/log/log-slice'
import logType from 'features/logType/logType-slice'
import machine from 'features/machine/machine-slice'
import marketingMetric from 'features/marketingMetric/marketingMetric-slice'
import media from 'features/media/media-slice'
import mediaAnalytics from 'features/mediaAnalytics/mediaAnalytics-slice'
import mediaCache from 'features/mediaCache/mediaCache-slice'
import mediaCustomizations from 'features/mediaCustomizations/mediaCustomizations-slice'
import mediaDescription from 'features/mediaDescription/mediaDescription-slice'
import mediaInformation from 'features/mediaInformation/mediaInformation-slice'
import mediaList from 'features/mediaList/mediaList-slice'
import mediaListItem from 'features/mediaListItem/mediaListItem-slice'
import mediaLog from 'features/mediaLog/mediaLog-slice'
import mediaProcessJob from 'features/mediaProcessJob/mediaProcessJob-slice'
import mediaProcessJobOverview from 'features/mediaProcessJobOverview/mediaProcessJobOverview-slice'
import mediaQualityAssuranceSettings from 'features/mediaQualityAssuranceSettings/mediaQualityAssuranceSettings-slice'
import mediaReactions from 'features/mediaReactions/mediaReactions-slice'
import mediaSnapshot from 'features/mediaSnapshot/mediaSnapshot-slice'
import mediaStatistic from 'features/mediaStatistic/mediaStatistic-slice'
import mediationProcess from 'features/mediationProcess/mediationProcess-slice'
import mediationProcessTemplate from 'features/mediationProcessTemplate/mediationProcessTemplate-slice'
import mediationStep from 'features/mediationStep/mediationStep-slice'
import metricConfiguration from 'features/metricConfiguration/metricConfiguration-slice'
import metricConfigurationVault from 'features/metricConfigurationVault/metricConfigurationVault-slice'
import metricCursor from 'features/metricCursor/metricCursor-slice'
import metricDeployment from 'features/metricDeployment/metricDeployment-slice'
import metricDeploymentConfig from 'features/metricDeploymentConfig/metricDeploymentConfig-slice'
import metricGraphScreen from 'features/metricGraphScreen/metricGraphScreen-slice'
import metricInitialization from 'features/metricInitialization/metricInitialization-slice'
import metricPeriod from 'features/metricPeriod/metricPeriod-slice'
import metricResult from 'features/metricResult/metricResult-slice'
import mobileCredentials from 'features/mobileCredentials/mobileCredentials-slice'
import mobileLoginProxy from 'features/mobileLoginProxy/mobileLoginProxy-slice'
import mobileLoginProxyConfirmation from 'features/mobileLoginProxyConfirmation/mobileLoginProxyConfirmation-slice'
import notification from 'features/notification/notification-slice'
import paymentHistory from 'features/paymentHistory/paymentHistory-slice'
import paymentInformation from 'features/paymentInformation/paymentInformation-slice'
import paymentMethod from 'features/paymentMethod/paymentMethod-slice'
import pendingBranding from 'features/pendingBranding/pendingBranding-slice'
import player from 'features/player/player-slice'
import playerInvite from 'features/playerInvite/playerInvite-slice'
import playerRole from 'features/playerRole/playerRole-slice'
import playlist from 'features/playlist/playlist-slice'
import playwatchSettings from 'features/playwatchSettings/playwatchSettings-slice'
import preferences from 'features/preferences/preferences-slice'
import processMediaFix from 'features/processMediaFix/processMediaFix-slice'
import processedBranding from 'features/processedBranding/processedBranding-slice'
import processedMedia from 'features/processedMedia/processedMedia-slice'
import processedMediaCustomizations from 'features/processedMediaCustomizations/processedMediaCustomizations-slice'
import processedMediaStates from 'features/processedMediaStates/processedMediaStates-slice'
import processedSocialMediaAccount from 'features/processedSocialMediaAccount/processedSocialMediaAccount-slice'
import profile from 'features/profile/profile-slice'
import profileComment from 'features/profileComment/profileComment-slice'
import profileImage from 'features/profileImage/profileImage-slice'
import profileMediaPreferences from 'features/profileMediaPreferences/profileMediaPreferences-slice'
import profileReaction from 'features/profileReaction/profileReaction-slice'
import profileRole from 'features/profileRole/profileRole-slice'
import profileStatus from 'features/profileStatus/profileStatus-slice'
import progress from 'features/progress/progress-slice'
import publicPlaylist from 'features/publicPlaylist/publicPlaylist-slice'
import purchasableItem from 'features/purchasableItem/purchasableItem-slice'
import purchasedItem from 'features/purchasedItem/purchasedItem-slice'
import quickConnect from 'features/quickConnect/quickConnect-slice'
import rawMetric from 'features/rawMetric/rawMetric-slice'
import releaseScheduleAction from 'features/releaseScheduleAction/releaseScheduleAction-slice'
import releaseZone from 'features/releaseZone/releaseZone-slice'
import reply from 'features/reply/reply-slice'
import season from 'features/season/season-slice'
import seasonSnapshot from 'features/seasonSnapshot/seasonSnapshot-slice'
import series from 'features/series/series-slice'
import seriesSnapshot from 'features/seriesSnapshot/seriesSnapshot-slice'
import socialMediaAccount from 'features/socialMediaAccount/socialMediaAccount-slice'
import squadMate from 'features/squadMate/squadMate-slice'
import subtitles from 'features/subtitles/subtitles-slice'
import system from 'features/system/system-slice'
import systemRole from 'features/systemRole/systemRole-slice'
import systemSetting from 'features/systemSetting/systemSetting-slice'
import tag from 'features/tag/tag-slice'
import targetGroup from 'features/targetGroup/targetGroup-slice'
import team from 'features/team/team-slice'
import thumbnail from 'features/thumbnail/thumbnail-slice'
import title from 'features/title/title-slice'
import titleChangeLog from 'features/titleChangeLog/titleChangeLog-slice'
import translation from 'features/translation/translation-slice'
import trimmedMedia from 'features/trimmedMedia/trimmedMedia-slice'
import user from 'features/user/user-slice'
import viewStatistic from 'features/viewStatistic/viewStatistic-slice'
import watchingMediaProfileMetric from 'features/watchingMediaProfileMetric/watchingMediaProfileMetric-slice'
import watchingPreviewProfileMetric from 'features/watchingPreviewProfileMetric/watchingPreviewProfileMetric-slice'
import watchingProfileMetric from 'features/watchingProfileMetric/watchingProfileMetric-slice'

import { applyMiddleware, compose } from 'redux'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import thunkMiddleware from 'redux-thunk'
// reducer import

import application from './features/application/application-slice'
import cartReducer from './store/cartReducer'
import customizationReducer from './store/customizationReducer'
import kanbanReducer from './store/kanbanReducer'
import snackbarReducer from './store/snackbarReducer'

/* Create root reducer, containing all features of the application */
const rootReducer = combineReducers({
  application,
  customization: customizationReducer,
  snackbar: snackbarReducer,
  cart: persistReducer(
    {
      key: 'cart',
      storage,
      keyPrefix: 'berry-',
    },
    cartReducer,
  ),
  kanban: kanbanReducer,
  user,
  profile,
  media,
  mediaList,
  mediaListItem,
  thumbnail,
  processedMedia,
  processedMediaStates,
  curatedMediaList,
  changeLog,
  playlist,
  releaseScheduleAction,
  releaseZone,
  viewStatistic,
  tag,
  device,
  account,
  comment,
  reply,
  profileComment,
  mediaCustomizations,
  socialMediaAccount,
  branding,
  log,
  feedback,
  mediaAnalytics,
  paymentInformation,
  preferences,
  history,
  paymentHistory,
  title,
  translation,
  titleChangeLog,
  player,
  address,
  notification,
  targetGroup,
  playerRole,
  team,
  flag,
  mediationProcess,
  mediationStep,
  profileStatus,
  issue,
  profileMediaPreferences,
  expressedPreference,
  squadMate,
  mediaLog,
  game,
  gameContext,
  gameArtifact,
  gameConfig,
  gameMarketingResource,
  marketingMetric,
  gameMetric,
  gameLog,
  logType,
  mediaQualityAssuranceSettings,
  playwatchSettings,
  mediaInformation,
  mediaReactions,
  profileReaction,
  mediaDescription,
  paymentMethod,
  pendingBranding,
  processedBranding,
  profileRole,
  brandingResource,
  commentCreateUpdateArg,
  deviceSettings,
  systemSetting,
  processedMediaCustomizations,
  processedSocialMediaAccount,
  category,
  categoryValue,
  mediationProcessTemplate,
  publicPlaylist,
  system,
  systemRole,
  playerInvite,
  contentCreator,
  contentHouse,
  profileImage,
  progress,
  contentCreatorInvitation,
  season,
  series,
  cast,
  approvalRequest,
  mediaSnapshot,
  seriesSnapshot,
  seasonSnapshot,
  approvalRequestLog,
  contentHouseMediaSnapshot,
  curatedSeriesList,
  coherentScreen,
  approvedSeries,
  approvedMedia,
  mediaProcessJob,
  mediaProcessJobOverview,
  machine,
  contentCreatorInvite,
  mobileLoginProxy,
  mobileCredentials,
  mobileLoginProxyConfirmation,
  coherentScreenMediaReference,
  rawMetric,
  metricPeriod,
  metricCursor,
  metricResult,
  metricConfiguration,
  metricDeployment,
  metricConfigurationVault,
  metricDeploymentConfig,
  genericResult,
  metricInitialization,
  metricGraphScreen,
  watchingMediaProfileMetric,
  watchingPreviewProfileMetric,
  processMediaFix,
  mediaCache,
  watchingProfileMetric,
  quickConnect,
  mediaStatistic,
  subtitles,
  customerSettings,
  customerAdministrator,
  trimmedMedia,
  contentCarrier,
  purchasedItem,
  purchasableItem,
  checkoutSession,
})
const middleWare = [thunkMiddleware]
const composeEnhancers =
  ((window as any)['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__'] as any) || compose
export const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(...middleWare)),
)
// createStore(rootReducer, /* preloadedState, */ devToolsEnhancer({}));
export const persister = persistStore(store)
export function dispatch(action: any) {
  return store.dispatch(action)
}
